<!--  -->
<template>
  <div>
    <section class="page-banner single-p-banner" style="background-image: url(/static/images/banner2.jpg);">
          <div class="container">
              <div class="row">
                  <div class="col-lg-7">
                      <a href="" class="post-cate" >北京</a>
                      <h2 class="banner-title">
                          {{liveInfo.title}}
                      </h2>
                      <div class="bp-meta">
                           <a href="">讲师：{{liveInfo.teacher}}</a>
                      </div>
                  </div>
              </div>
          </div>
    </section>  
    <section class="course-details-section">
      <div class="container">
          <div class="row">
              <div class="col-lg-8">
                  <div class="single-course-area">
                      <div class="course-top">
                          <h4>{{liveInfo.title}}</h4>
                          <div class="course-meta">
                              <div class="author">
                                  <img src="/static/images/home3/course/a1.png" alt="">
                                  <span>讲师:</span>
                                  <a>{{liveInfo.teacher}}</a>
                              </div>
                              <div class="categories">
                                  <span>所属科目:</span>
                                  <a >{{liveInfo.type}}</a>
                              </div>
                              <div class="ratings">
                                  <span>直播时间：</span>
                                  <a >{{dateFormat(new Date(liveInfo.time),"yyyy-MM-dd hh:mm")}}</a>
                              </div>
                          </div>
                          <div class="course-price" style="text-align:center">
                            <span> 在线人数</span>
                                 {{linvClient?linvClient.active:0}}
                              
                          </div>
                      </div>
                      <div class="sc-thumb">
                          <!-- <vue-baberrage
                            :isShow= "barrageIsShow"
                            :barrageList = "barrageList"
                            :loop = "barrageLoop"
                            :style="`height: ${videoHigh};z-index: 80`"
                            @dbclick="chgPlaystatus"
                            >
                          </vue-baberrage> -->
                          <el-empty v-if="!isLiving" description="课程讲师暂未开播，去逛逛在线课程吧！" style="background-color: #fff;"></el-empty>
                          <!-- <video-play v-else-if="flvInfo" :flvInfo="flvInfo"></video-play> -->
                          <!-- <LivePlayer v-else-if="flvInfo" :videoUrl="flvInfo.url" fluent autoplay live stretch></LivePlayer> -->
                          <div id="jh_live" style="width:100%; height:auto;" ref="VideoPlay"></div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4">
                <div class="course-sidebar">
                    <aside class="widget">
                            <div class="info-course">
                              <label>聊天室</label>
                              <div class="chat-content" id="chatRecord" style="overflow: auto;" updated>
                                  <!-- recordContent 聊天记录数组-->
                                  <div v-for="(itemc,indexc) in recordContent" :key="indexc">
                                        <!-- 对方 -->
                                        <div class="word" v-if="!itemc.mineMsg">
                                            <img :src="itemc.headUrl">
                                            <div class="info">
                                                  <p class="time">{{itemc.nickName}}  {{itemc.timestamp}}</p>
                                                  <div class="info-content">{{itemc.contactText}}</div>
                                            </div>
                                        </div> 
                                        <!-- 我的 -->
                                        <div class="word-my" v-else>
                                            <div class="info">
                                                  <p class="time">{{itemc.nickName}}  {{itemc.timestamp}}</p>
                                                  <div class="info-content">{{itemc.contactText}}</div>
                                            </div>
                                            <img :src="itemc.headUrl">
                                        </div>
                                    </div>
                              </div>
                               
                            </div><!-- end preview-video-and-details -->
                            <el-input placeholder="请输入聊天内容" style="margin-top: 10px;" v-model="msg" >
                                  <el-button slot="append" @click="addToList()">发送</el-button>
                            </el-input>
                       <!-- end sidebar-widget -->
                      
                    </aside>
                </div>
              </div>
          </div>
      </div>
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
//import VideoPlay from "../components/PublicComs/VideoPlay.vue";
// import { MESSAGE_TYPE } from 'vue-baberrage'
export default {
  data() {
    return {
      global,
      liveInfo: {},
      flvInfo: null,
      isLiving: true,
      recordContent:[],
      linvClient: {},
      msg: '',
      barrageIsShow: true,
      currentId : 0,
      barrageLoop: false,
      barrageList: [],
      videoHigh:100,
      player:{},
      timer:{}
    };
  },
  props: {
    plates: Array,
  },
  components: { },

  computed: {},
    updated(){
        // 聊天定位到底部
          let ele = document.getElementById('chatRecord');
          ele.scrollTop = ele.scrollHeight;
      },

  mounted() {
    let liveId = this.$route.params.id;
   // let liveId = "61ac6fc73ffc156948d5aa6b";
    this.$axios.get(`/api/livings/${liveId}`).then((res) => {
      if (res.data) {
        this.liveInfo = res.data.data;
        if (!this.liveInfo.addtime) {
          let addtime = this.liveInfo.createdAt;
          let date = new Date(addtime);
          this.liveInfo.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        if(this.liveInfo.state!==1)
        {
           this.isLiving = false;
           return;  
        }
        this.flvInfo = {
          id: this.liveInfo._id,
          url: this.global.liveIp + liveId + ".flv",
        }; 
        this.playVideo(this.global.liveIp + liveId);//".m3u8"
        this.$nextTick(function(){
          this.videoHigh = (this.$refs.VideoPlay.clientHeight - 20)/1.5 + "px";
        })
      }
    });
    this.joinLiveRoom(liveId);
    this.$axios.get("/users/"+liveId).then((res)=>{
      if (res&&res.data)
      {
        this.linvClient.active = res.data.data;
        this.$forceUpdate();
      }
    })
    this.timer =setInterval(()=>{
      this.$axios.get("/users/"+liveId).then((res)=>{
      if (res&&res.data)
      {
        this.linvClient.active = res.data.data;
        this.$forceUpdate();
      }
    })
    },1000*60);
    this.$socketBarrage.on("chatLiveRoom", (res) => {
      console.log(res)
      this.barrageList.push({
        id: ++this.currentId,
        avatar: "/static/images/avatar.png",
        msg: res.msg,
        time: 5,
        type: MESSAGE_TYPE.NORMAL,
      });
      this.recordContent.push({
        mineMsg:res.user==this.$store.getters.user.name,
        nickName:res.user,
        timestamp:this.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss"),
        headUrl:"/static/images/avatar.png",
        contactText:res.msg
      })
      this.$nextTick(() => {
       // this.$refs.barrageList.scrollTop = this.$refs.barrageList.clientHeight;
      });
    });
    window.addEventListener("keydown", this.keyDown);
    window.addEventListener('beforeunload', () =>{
      console.log("come here")
      this.leaveLiveRoom(this.liveInfo._id)
    })
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDown, false);
    clearInterval(this.timer);
  },
  
  methods: {
    chgPlaystatus(){
      this.player.togglePlay();
    },
    addToList (){
      //发送弹幕
      if(!this.msg)return;
      let data = {
        room: this.liveInfo._id,
        func: "chatLiveRoom",
        data: {
          id: this.global.getCode(8),
          user: this.$store.getters.user.name,
          msg: this.msg,
        },
      };
      this.msg ="";
      this.$sockBarrage.roomChat(data);
      // this.barrageList.push({
      //   id: ++this.currentId,
      //   avatar: "/static/images/avatar.png",
      //   msg: this.msg,
      //   time: 5,
      //   type: MESSAGE_TYPE.NORMAL,
      // });
      // this.recordContent.push({
      //   mineMsg:true,
      //   nickName:this.$store.getters.user.name,
      //   timestamp:this.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss"),
      //   headUrl:"/static/images/avatar.png",
      //   contactText:this.msg
      // })
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    //加入直播间
    joinLiveRoom(name) {
      this.$sockBarrage.joinRoom(name);
    },

    //离开直播间
    leaveLiveRoom(name) {
      this.$sockBarrage.leaveRoom(name);
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.addToList();
      }
    },
    playVideo(url) {
        document.getElementById('jh_live').innerHTML = ""
        this.player = new this.TcPlayer('jh_live', {
          "m3u8": url, //请替换成实际可用的播放地址
          "autoplay": true, //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          // "poster": img,
          "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
          "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
          "remember": 1
        });
      },
  },
};
</script>
<style scoped>
::v-deep .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
::v-deep .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
::v-deep .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
::v-deep .el-empty__description p{
  color: #ff0000;
    font-size: 20px;
    margin: 0;
    font-weight: 600;
}
.chat-content {
  width: 100%;
  padding: 20px;
  height: 460px;
  box-shadow: 0 2px 2px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
}
.chat-content .word {
  display: flex;
  margin-bottom: 20px;
}
.chat-content .word img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.chat-content .word .info {
  margin-left: 10px;
}
.chat-content .word .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
}
.chat-content .word .info .info-content {
  padding: 10px;
  font-size: 14px;
  background: #fff;
  position: relative;
  margin-top: 8px;
}
.chat-content .word .info .info-content::before {
  position: absolute;
  left: -8px;
  top: 8px;
  content: "";
  border-right: 10px solid #fff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

.word-my {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.word-my img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.word-my .info {
  width: 90%;
  margin-left: 10px;
  text-align: right;
}
.word-my .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
  margin-right: 10px;
}
.word-my .info .info-content {
  max-width: 70%;
  padding: 10px;
  font-size: 14px;
  float: right;
  margin-right: 10px;
  position: relative;
  margin-top: 8px;
  background: #a3c3f6;
  text-align: left;
}
.word-my .info .info-content::after {
  position: absolute;
  right: -8px;
  top: 8px;
  content: "";
  border-left: 10px solid #a3c3f6;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}
 
::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}
 
::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}
 
::-webkit-scrollbar-track {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}
 
::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}
 
::-webkit-scrollbar-corner {
  background: transparent;
}
a:not([href]):not([tabindex]) {
    color: initial !important;
}
</style>
